module.exports = __webpack_public_path__ + "static/vmware_27.1f75557a.jpg";